<template>
	<v-col class="sponsorisasi">
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Genealogy</div>
		</div>
		<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
			<v-icon small color="grey">mdi-account-group</v-icon>
			<div class="pl-2">Jaringan</div>
			<div class="px-2">/</div>
			<div>Genealogy</div>
		</div>
		<div class="mt-5">
			<v-row>
				<v-col cols="12" sm="6" md="5">
					<div class="d-flex">
						<v-text-field placeholder="Kode Mitra" outlined dense background-color="white" class="rounded-lg date-no-border" hide-details v-model="code_member"></v-text-field>
						<v-btn depressed height="40" color="primary" class="ml-2 mx-sm-3 white--text rounded-lg text-capitalize" @click="searchGene">
							<span>Cari</span>
						</v-btn>
					</div>
				</v-col>

				<template v-if="!loading">
					<v-col cols="12" sm="12" md="12" v-if="Object.values(listGenealogy).length > 0">
						<div class="d-block d-md-none mb-5">
							<div v-if="listGenealogy['1'].network_code != userData.bin_network_code" class="d-flex flex-column align-center justify-centermb-4">
								<v-btn outlined block color="primary" class="pl-2 pr-2 mb-2 text-capitalize" @click="backGene(listGenealogy['1'].upline_network_code)">
									<v-icon>mdi-chevron-left</v-icon>
									<span>Lihat Jaringan Sebelumnya</span>
								</v-btn>
								<v-btn outlined block color="primary" class="pl-2 pr-2 text-capitalize" @click="backGene(myProfile.network_code)">
									<v-icon>mdi-account-network</v-icon>
									<span class="pl-1">Lihat Jaringan Saya</span>
								</v-btn>
							</div>
						</div>

						<div class="d-none d-md-block">
							<div v-if="listGenealogy['1'].network_code != userData.bin_network_code" class="d-flex flex-row align-center justify-space-between mb-4">
								<v-btn outlined color="primary" class="pl-2 pr-2 text-capitalize" @click="backGene(listGenealogy['1'].upline_network_code)">
									<v-icon>mdi-chevron-left</v-icon>
									<span>Lihat Jaringan Sebelumnya</span>
								</v-btn>
								<v-btn outlined color="primary" class="pl-2 pr-2 text-capitalize" @click="backGene(myProfile.network_code)">
									<v-icon>mdi-account-network</v-icon>
									<span class="pl-1">Lihat Jaringan Saya</span>
								</v-btn>
							</div>
						</div>

						<div class="chart-genealogy" :class="{'mobile-genealogy': isMobile}">
							<table class="bg-light-primary">
								<tbody>
									<tr>
										<td colspan="4" class="bg-light-primary">
											<CardGenealogy :data="listGenealogy['1']" :clickable="false"></CardGenealogy>
										</td>
									</tr>
									<tr>
										<td colspan="4" class="bg-light-primary">
											<div class="node-shadow"></div>
										</td>
									</tr>
									<tr>
										<td class="chart-line left"></td>
										<td class="chart-line right top"></td>
										<td class="chart-line left top"></td>
										<td class="chart-line right"></td>
									</tr>
									<tr>
										<td colspan="2" class="bg-light-primary">
											<table class="bg-light-primary">
												<tbody>
													<tr>
														<td colspan="4" class="bg-light-primary">
															<CardGenealogy :data="listGenealogy['2']"></CardGenealogy>
														</td>
													</tr>
													<tr>
														<td colspan="4" class="bg-light-primary">
															<div class="node-shadow"></div>
														</td>
													</tr>
													<tr>
														<td class="chart-line left"></td>
														<td class="chart-line right top"></td>
														<td class="chart-line left top"></td>
														<td class="chart-line right"></td>
													</tr>
													<tr>
														<td colspan="2" class="bg-light-primary">
															<table class="bg-light-primary">
																<tbody>
																	<tr>
																		<td colspan="4" class="bg-light-primary">
																			<CardGenealogy :data="listGenealogy['4']"></CardGenealogy>
																		</td>
																	</tr>
																	<tr>
																		<td colspan="4" class="bg-light-primary">
																			<div class="node-shadow"></div>
																		</td>
																	</tr>
																	<tr :class="{'d-none' : isMobile}">
																		<td class="chart-line left"></td>
																		<td class="chart-line right top"></td>
																		<td class="chart-line left top"></td>
																		<td class="chart-line right"></td>
																	</tr>
																	<tr :class="{'d-none' : isMobile}">
																		<td colspan="2" class="bg-light-primary">
																			<table class="bg-light-primary">
																				<tbody>
																					<tr>
																						<td colspan="4" class="bg-light-primary">
																							<CardGenealogy :data="listGenealogy['8']"></CardGenealogy>
																						</td>
																					</tr>
																				</tbody>
																			</table>
																		</td>
																		<td colspan="2" class="bg-light-primary">
																			<table class="bg-light-primary">
																				<tbody>
																					<tr>
																						<td colspan="4" class="bg-light-primary">
																							<CardGenealogy :data="listGenealogy['9']"></CardGenealogy>
																						</td>
																					</tr>
																				</tbody>
																			</table>
																		</td>
																	</tr>
																</tbody>
															</table>
														</td>
														<td colspan="2" class="bg-light-primary">
															<table class="bg-light-primary">
																<tbody>
																	<tr>
																		<td colspan="4" class="bg-light-primary">
																			<CardGenealogy :data="listGenealogy['5']"></CardGenealogy>
																		</td>
																	</tr>
																	<tr>
																		<td colspan="4" class="bg-light-primary">
																			<div class="node-shadow"></div>
																		</td>
																	</tr>
																	<tr :class="{'d-none' : isMobile}">
																		<td class="chart-line left"></td>
																		<td class="chart-line right top"></td>
																		<td class="chart-line left top"></td>
																		<td class="chart-line right"></td>
																	</tr>
																	<tr :class="{'d-none' : isMobile}">
																		<td colspan="2" class="bg-light-primary">
																			<table class="bg-light-primary">
																				<tbody>
																					<tr>
																						<td colspan="4" class="bg-light-primary">
																							<CardGenealogy :data="listGenealogy['10']"></CardGenealogy>
																						</td>
																					</tr>
																				</tbody>
																			</table>
																		</td>
																		<td colspan="2" class="bg-light-primary">
																			<table class="bg-light-primary">
																				<tbody>
																					<tr>
																						<td colspan="4" class="bg-light-primary">
																							<CardGenealogy :data="listGenealogy['11']"></CardGenealogy>
																						</td>
																					</tr>
																				</tbody>
																			</table>
																		</td>
																	</tr>
																</tbody>
															</table>
														</td>
													</tr>
												</tbody>
											</table>
										</td>
										<td colspan="2" class="bg-light-primary">
											<table class="bg-light-primary">
												<tbody>
													<tr>
														<td colspan="4" class="bg-light-primary">
															<CardGenealogy :data="listGenealogy['3']"></CardGenealogy>
														</td>
													</tr>
													<tr>
														<td colspan="4" class="bg-light-primary">
															<div class="node-shadow"></div>
														</td>
													</tr>
													<tr>
														<td class="chart-line left"></td>
														<td class="chart-line right top"></td>
														<td class="chart-line left top"></td>
														<td class="chart-line right"></td>
													</tr>
													<tr>
														<td colspan="2" class="bg-light-primary">
															<table class="bg-light-primary">
																<tbody>
																	<tr>
																		<td colspan="4" class="bg-light-primary">
																			<CardGenealogy :data="listGenealogy['6']"></CardGenealogy>
																		</td>
																	</tr>
																	<tr>
																		<td colspan="4" class="bg-light-primary">
																			<div class="node-shadow"></div>
																		</td>
																	</tr>
																	<tr :class="{'d-none' : isMobile}">
																		<td class="chart-line left"></td>
																		<td class="chart-line right top"></td>
																		<td class="chart-line left top"></td>
																		<td class="chart-line right"></td>
																	</tr>
																	<tr :class="{'d-none' : isMobile}">
																		<td colspan="2" class="bg-light-primary">
																			<table class="bg-light-primary">
																				<tbody>
																					<tr>
																						<td colspan="4" class="bg-light-primary">
																							<CardGenealogy :data="listGenealogy['12']"></CardGenealogy>
																						</td>
																					</tr>
																				</tbody>
																			</table>
																		</td>
																		<td colspan="2" class="bg-light-primary">
																			<table class="bg-light-primary">
																				<tbody>
																					<tr>
																						<td colspan="4" class="bg-light-primary">
																							<CardGenealogy :data="listGenealogy['13']"></CardGenealogy>
																						</td>
																					</tr>
																				</tbody>
																			</table>
																		</td>
																	</tr>
																</tbody>
															</table>
														</td>
														<td colspan="2" class="bg-light-primary">
															<table class="bg-light-primary">
																<tbody>
																	<tr>
																		<td colspan="4" class="bg-light-primary">
																			<CardGenealogy :data="listGenealogy['7']"></CardGenealogy>
																		</td>
																	</tr>
																	<tr>
																		<td colspan="4" class="bg-light-primary">
																			<div class="node-shadow"></div>
																		</td>
																	</tr>
																	<tr :class="{'d-none' : isMobile}">
																		<td class="chart-line left"></td>
																		<td class="chart-line right top"></td>
																		<td class="chart-line left top"></td>
																		<td class="chart-line right"></td>
																	</tr>
																	<tr :class="{'d-none' : isMobile}">
																		<td colspan="2" class="bg-light-primary">
																			<table class="bg-light-primary">
																				<tbody>
																					<tr>
																						<td colspan="4" class="bg-light-primary">
																							<CardGenealogy :data="listGenealogy['14']"></CardGenealogy>
																						</td>
																					</tr>
																				</tbody>
																			</table>
																		</td>
																		<td colspan="2" class="bg-light-primary">
																			<table class="bg-light-primary">
																				<tbody>
																					<tr>
																						<td colspan="4" class="bg-light-primary">
																							<CardGenealogy :data="listGenealogy['15']"></CardGenealogy>
																						</td>
																					</tr>
																				</tbody>
																			</table>
																		</td>
																	</tr>
																</tbody>
															</table>
														</td>
													</tr>
												</tbody>
											</table>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</v-col>

					<v-col cols="12" sm="12" md="12" v-else>
						<v-card class="py-3 elevation-0 hover-shadow rounded-lg">
							<NoData></NoData>
							<div class="pt-3 text-center cl-secondary">Tidak ada data mitra yang dapat ditampilkan</div>
							<div class="pt-3 mb-4 text-center">
								<v-btn outlined color="primary" class="pl-2 pr-2 text-capitalize" @click="backGene(myProfile.network_code)">
									<v-icon>mdi-account-network-outline</v-icon>
									<span class="pl-1">Kembali ke Jaringan Saya</span>
								</v-btn>
							</div>
						</v-card>
					</v-col>
				</template>

				<template v-else>
					<v-col cols="12" sm="12" md="12">
						<LoadData :loading="loading"></LoadData>
					</v-col>
				</template>
			</v-row>
		</div>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import CardGenealogy from './components/CardGenealogy';

export default {
	components: {
		CardGenealogy
	},
	data() {
		return {
			loading: false,
			code_member: '',
			isMobile: false
		}
	},
	computed: {
		...mapState('profile', ['myProfile']),
		...mapState('auth', ['userData']),
		...mapState('network', ['listGenealogy']),
		windowWidth() {
      return this.getWindowWidth()
		}
	},
	methods: {
		...mapActions('network', ['getGenealogy', 'getGenealogyMobile']),
		...mapActions('profile', ['getProfile']),

		getWindowWidth() {
      let screen = document.documentElement.clientWidth
      if (screen <= 767) this.isMobile = true
      else this.isMobile = false
		},
		searchGene() {
			this.getGenealogy({network_code:this.code_member})
			this.code_member = ''
		},
		backGene(code) {
			this.getGenealogy({network_code:code})
		}
	},
	watch: {
	},
	async created(){
		await this.$store.dispatch('setPageTitle', `Genealogy`)
		await this.getWindowWidth()
		await window.addEventListener('resize', this.getWindowWidth)
		this.loading = await true

		await this.getGenealogy()

		setTimeout(() => {
			this.loading = false
		}, 1000);
	},
  destroyed() {
    window.addEventListener('resize', this.getWindowWidth)
  }
};
</script>